export const SectionHeader = ({ overline, title, subtitle, action, className = '' }) => (
  <div className={`mb-3 flex items-end justify-between gap-3 ${className}`}>
    <div className="min-w-0">
      {overline && <p className="text-[11px] font-semibold uppercase tracking-widest text-[#71717a]">{overline}</p>}
      <h2 className="font-heading text-base font-semibold text-white md:text-lg">{title}</h2>
      {subtitle && <p className="mt-0.5 text-sm text-[#a1a1aa]">{subtitle}</p>}
    </div>
    {action && <div className="shrink-0">{action}</div>}
  </div>
);

export const Card = ({ children, className = '', ...props }) => (
  <div className={`rounded-2xl border border-white/[0.06] bg-[#18181b] ${className}`} {...props}>
    {children}
  </div>
);

export const EmptyState = ({ icon: Icon, title, message, testId }) => (
  <Card className="px-6 py-14 text-center" data-testid={testId}>
    <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-white/[0.04]">
      <Icon className="h-7 w-7 text-[#52525b]" />
    </div>
    <h3 className="font-heading text-base font-semibold text-white">{title}</h3>
    <p className="mx-auto mt-1 max-w-xs text-sm text-[#a1a1aa]">{message}</p>
  </Card>
);
